import {
    Text,
    Bleed,
    BlockStack,
    Button,
    Card,
    Divider,
    InlineStack,
    RadioButton,
    TextField,
    Banner,
    InlineError,
} from '@shopify/polaris';
import { DeleteMinor, PlusMinor } from '@shopify/polaris-icons';
import React from 'react';
import { DI, DIProps } from '../../../../../Core';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '../../../../Utilities/useMediaQuery';

interface Props extends DIProps {
    businessPrice?: any;
    savedPriceSettings: any;
    contextualSaveBarData: any;
    myErrors: any;
    showBusinessPrice: boolean;
    savedShowBusinessPrice: boolean;
    setShowBusinessPrice: (props: any) => void;
    setErrors: (props: any) => void;
    setContextualSaveBarData: (props: any) => void
    setPriceSettings: (props: any) => void
    syncNecessaryInfo: () => void;
    syncConnectorInfo: (props: any, shop_url?: string | null, updateCurrentShop?: boolean, updateStepStatus?: React.Dispatch<React.SetStateAction<string>>) => void;
    syncProfileInfo: () => void;
    loginStatus: () => void;
    syncServices: () => void;
}

const AddDiscounts = (props: Props) => {
    const { t } = useTranslation();
    const { businessPrice } = props;
    const isMobile = useMediaQuery('(max-width: 650px)');

    const handleAddRow = (discountType: string) => {
        let tempBusinessPrice = JSON.parse(JSON.stringify(businessPrice));
        let tempErrors = JSON.parse(JSON.stringify(props.myErrors))

        tempBusinessPrice[discountType].push({ quantity: '', price: '' });
        tempErrors.business_price[discountType].push({ quantity: false, price: false, touched: { quantity: false, price: false } });
        props.setErrors(tempErrors);
        props.setPriceSettings((prev: any) => ({
            ...prev,
            business_price: tempBusinessPrice
        }))

        if (JSON.stringify(props.savedPriceSettings.business_price[discountType]) != JSON.stringify(tempBusinessPrice[discountType])) props.setContextualSaveBarData((prev: any) => ({
            ...prev,
            ['business_price' + "_" + discountType]: true
        }))
        else props.setContextualSaveBarData((prev: any) => ({
            ...prev,
            ['business_price' + "_" + discountType]: false
        }))
    };

    const handleDeleteRow = (index: number, discountType: string) => {
        let tempQuantityDiscount = JSON.parse(JSON.stringify(businessPrice[discountType]));
        let tempErrors = JSON.parse(JSON.stringify(props.myErrors));
        tempErrors.business_price[discountType].splice(index, 1);
        props.setErrors(JSON.parse(JSON.stringify(tempErrors)))
        tempQuantityDiscount.splice(index, 1);
        props.setPriceSettings((prev: any) => ({
            ...prev,
            business_price: {
                ...prev.business_price,
                [discountType]: [...tempQuantityDiscount]
            }
        }))

        if (JSON.stringify(props.savedPriceSettings.business_price[discountType]) != JSON.stringify(tempQuantityDiscount)) props.setContextualSaveBarData((prev: any) => ({
            ...prev,
            ['business_price' + "_" + discountType]: true,
            ['quantity_change' + discountType + index + 'price']: false,
            ['quantity_change' + discountType + index + 'quantity']: false
        }))
        else props.setContextualSaveBarData((prev: any) => ({
            ...prev,
            ['business_price' + "_" + discountType]: false,
            ['quantity_change' + discountType + index + 'price']: false,
            ['quantity_change' + discountType + index + 'quantity']: false
        }))
    }

    const handleQuantityChange = (key: string, value: any, index: number, discountType: string) => {
        let tempErrors = JSON.parse(JSON.stringify(props.myErrors));
        if (tempErrors.business_price[discountType]?.[index]?.['touched']?.[key] == false) tempErrors.business_price[discountType][index]['touched'][key] = true;
        props.setErrors(JSON.parse(JSON.stringify(tempErrors)));
        let tempQuantityDiscount = JSON.parse(JSON.stringify(businessPrice[discountType]));
        tempQuantityDiscount[index][key] = value;
        props.setPriceSettings((prev: any) => ({
            ...prev,
            business_price: {
                ...prev.business_price,
                [discountType]: [...tempQuantityDiscount]
            }
        }));

        if (JSON.stringify(props.savedPriceSettings.business_price?.[discountType]?.[index]?.[key] ?? '') != JSON.stringify(value)) props.setContextualSaveBarData((prev: any) => ({
            ...prev,
            ['quantity_change' + discountType + index + key]: true,
            ['business_price' + "_" + [discountType]]: JSON.stringify(props.savedPriceSettings.business_price?.[discountType]) != JSON.stringify(tempQuantityDiscount)
        }));
        else props.setContextualSaveBarData((prev: any) => ({
            ...prev,
            ['quantity_change' + discountType + index + key]: false,
            ['business_price' + "_" + [discountType]]: JSON.stringify(props.savedPriceSettings.business_price?.[discountType]) != JSON.stringify(tempQuantityDiscount)
        }));
    }

    const handleClearAll = (discountType: string) => {
        props.setPriceSettings((prev: any) => ({
            ...prev,
            business_price: {
                ...prev.business_price,
                [discountType]: [{ quantity: '', price: '' }]
            }
        }))
    }

    const discountType = businessPrice.quantity_type == "fixed" ? "fixed_discount" : "percentage_discount";

    return (
        <BlockStack gap={'300'}>
            <InlineStack align="space-between" gap={'200'}>
                <Button
                    variant="plain"
                    disclosure={props.showBusinessPrice ? 'up' : 'down'}
                    onClick={() => {
                        props.setShowBusinessPrice(!props.showBusinessPrice);
                        if (JSON.stringify(props.savedShowBusinessPrice) != JSON.stringify(!props.showBusinessPrice)) props.setContextualSaveBarData((prev: any) => ({
                            ...prev,
                            business_price_add_discount_btn: true
                        }));
                        else props.setContextualSaveBarData((prev: any) => ({
                            ...prev,
                            business_price_add_discount_btn: false
                        }))
                    }}>
                    {t("Add discounts on orders quantity")}
                </Button>
                {/* <Button
                    variant="plain"
                    disabled={businessPrice[discountType]?.length === 1}
                    tone="critical"
                    onClick={() => {
                        handleClearAll(discountType);
                    }}>
                    {t("Clear all")}
                </Button> */}
            </InlineStack>
            {props.showBusinessPrice && (
                <Card background="bg-surface" padding={'025'}>
                    <div className="custom-discount-wrapper">
                        <BlockStack gap={"200"}>
                            <BlockStack gap={'150'}>
                                <InlineStack gap={'300'} align="space-between">
                                    <InlineStack gap={'300'}>
                                        <RadioButton
                                            label={t("Value")}
                                            id="fix"
                                            name="discounts"
                                            onChange={(e: any, id: any) => {
                                                props.setPriceSettings((prevState: any) => ({
                                                    ...prevState,
                                                    business_price: {
                                                        ...prevState.business_price,
                                                        'quantity_type': "fixed",
                                                    }
                                                }));

                                                let tempErrors = JSON.parse(JSON.stringify(props.myErrors));
                                                tempErrors.business_price.quantity_type = false;
                                                props.setErrors(JSON.parse(JSON.stringify(tempErrors)));

                                                if (JSON.stringify(props.savedPriceSettings.business_price?.quantity_type) != JSON.stringify("fixed")) props.setContextualSaveBarData((prev: any) => ({
                                                    ...prev,
                                                    quantity_type: true
                                                }));
                                                else props.setContextualSaveBarData((prev: any) => ({
                                                    ...prev,
                                                    quantity_type: false
                                                }));
                                            }}
                                            checked={businessPrice.quantity_type === 'fixed'}
                                        />
                                        <RadioButton
                                            label={t("Percentage")}
                                            id="percent"
                                            name="discounts"
                                            onChange={(e: any, id: any) => {
                                                props.setPriceSettings((prevState: any) => ({
                                                    ...prevState,
                                                    business_price: {
                                                        ...prevState.business_price,
                                                        'quantity_type': id,
                                                    }
                                                }));

                                                let tempErrors = JSON.parse(JSON.stringify(props.myErrors));
                                                tempErrors.business_price.quantity_type = false;
                                                props.setErrors(JSON.parse(JSON.stringify(tempErrors)));

                                                if (JSON.stringify(props.savedPriceSettings.business_price?.quantity_type) != JSON.stringify("percent")) props.setContextualSaveBarData((prev: any) => ({
                                                    ...prev,
                                                    quantity_type: true
                                                }));
                                                else props.setContextualSaveBarData((prev: any) => ({
                                                    ...prev,
                                                    quantity_type: false
                                                }));
                                            }}
                                            checked={businessPrice.quantity_type === 'percent'}
                                        />
                                    </InlineStack>
                                    {props.myErrors.business_price?.quantity_type && <InlineError message={t("Kindly select 'Value' or 'Percentage' option to add discounts on orders quantity.")} fieldID={'quantityDiscounts'} />}
                                </InlineStack>
                                <Bleed marginInline={'400'}>
                                    <Divider />
                                </Bleed>
                            </BlockStack>
                            {businessPrice['quantity_type'] &&
                                <BlockStack gap={'200'}>
                                    <BlockStack gap={"300"}>
                                        {businessPrice[discountType]?.map((ele: any, index: number) => {
                                            return (
                                                <BlockStack gap={"100"} key={index}>
                                                    <Text as='p' fontWeight='medium' variant='bodyMd' tone='subdued'>{`${t("Quantity Tier")} ${index + 1}`}</Text>
                                                    <BlockStack gap={"200"}>
                                                        <InlineStack
                                                            align="space-between"
                                                            key={index}
                                                            gap={"300"}
                                                        // blockAlign='center'
                                                        >
                                                            <div className={isMobile ? "" : "flex-1"}>
                                                                <TextField
                                                                    autoComplete="off"
                                                                    label={t("Minimum order quantity")}
                                                                    placeholder={t("Enter value")}
                                                                    value={ele.quantity}
                                                                    onChange={(e: any) => {
                                                                        e = e.toString()
                                                                            .replace(/[\sa-zA-Z-!$%^&*()@_+|~=`\\#{}\[\]:";'<>?,.\/]/gi, "");
                                                                        handleQuantityChange("quantity", e, index, discountType);
                                                                    }}
                                                                    error={props.myErrors.business_price?.[discountType]?.[index]?.['quantity']}
                                                                />
                                                            </div>
                                                            <div className={isMobile ? "" : "flex-1"}>
                                                                <TextField
                                                                    placeholder={businessPrice.quantity_type == "fixed" ? t("Enter price") : t("Enter percentage")}
                                                                    autoComplete="off"
                                                                    label={`${businessPrice.quantity_type == "fixed" ? t("Your discount price/unit") : t("Your discount percentage/unit")}`}
                                                                    value={ele.price}
                                                                    onChange={(e: any) => {
                                                                        e = e.trim().replace(/[a-zA-Z-!$%^&*()@_+|~=`\\#{}\[\]:";'<>?,\/]/gi, '');
                                                                        e = e?.[0] === '.' ? '0' + e : e;
                                                                        e = (e.split(".").length - 1 > 1 ? e.slice(0, -1) : e).replace(/^(\d+.?\d{0,2})\d*$/, "$1");
                                                                        handleQuantityChange("price", e, index, discountType);
                                                                    }}
                                                                    prefix={businessPrice.quantity_type == "fixed" ? null : "%"}
                                                                    error={props.myErrors.business_price?.[discountType]?.[index]?.['price']}
                                                                    disabled={businessPrice?.[discountType]?.[index]?.quantity == ""}
                                                                />
                                                            </div>
                                                            <div className="custom-discount-delete__btn flex">
                                                                <Button
                                                                    icon={DeleteMinor}
                                                                    variant="tertiary"
                                                                    tone="critical"
                                                                    disabled={businessPrice[discountType].length === 1}
                                                                    onClick={() => {
                                                                        handleDeleteRow(index, discountType)
                                                                    }}
                                                                />
                                                            </div>
                                                        </InlineStack>
                                                        <BlockStack gap={"100"}>
                                                            {props.myErrors.business_price?.[discountType]?.[index]?.hasError && (
                                                                props.myErrors.business_price?.[discountType]?.[index].errors.map((errMsg: string, idx: number) => (
                                                                    <InlineError message={errMsg} fieldID={`${errMsg}_${idx}`}></InlineError>
                                                                ))
                                                            )}
                                                        </BlockStack>
                                                    </BlockStack>
                                                </BlockStack>
                                            );
                                        })}
                                    </BlockStack>
                                    <InlineStack align="start">
                                        <Button
                                            disabled={businessPrice[discountType].length === 5}
                                            icon={PlusMinor}
                                            variant="tertiary"
                                            onClick={() => handleAddRow(discountType)}>
                                            {t("Add a new discount rule")}
                                        </Button>
                                    </InlineStack>
                                    <Banner>
                                        {t("If you want to set a new business price without giving discounts on the order quantity then first should switch off the old business price to clear the data. Then, switch it on again to apply the relevant settings.")}
                                    </Banner>
                                </BlockStack>}
                        </BlockStack>
                    </div>
                </Card >
            )}
        </BlockStack >
    );
};

export default DI(AddDiscounts);
